import React, { useState } from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./PublishConfirmDialog.scss";

interface PublishConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const PublishConfirmDialog: React.FC<PublishConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [publishText, setPublishText] = useState("Publish");
  const [isSaving, setIsSaving] = useState(false);
  
  return (
    <>
      {isOpen && (
        <div className="publish-confirm-dialog">
          <div className="publish-confirm-content">
            <div className="publish-confirm-header">
              <h3 className="publish-confirm-title">Publish changes</h3>
              <Button
                type="text"
                icon={<CloseOutlined />}
                disabled={isSaving}
                onClick={onClose}
                className="close-btn"
              />
            </div>

            <div className="publish-confirm-body">
              <p>Are you sure you want to publish your changes?</p>
            </div>

            <div className="publish-confirm-footer">
              <Button onClick={onClose} className="cancel-btn" disabled={isSaving}>
                Cancel
              </Button>
              <Button
                type="primary"
                disabled={isSaving}
                onClick={async () => {
                  if (isSaving) return;
                  setIsSaving(true);
                  setPublishText("Publishing...");
                  try {
                    await onConfirm();
                    setPublishText("Published!");
                  } catch (error) {
                    console.error("Failed to publish flow:", error);
                    setPublishText("Error Publishing");
                  }
                  setTimeout(() => {
                    setPublishText("Publish");
                    setIsSaving(false);
                    onClose();
                  }, 3000);
                }}
                className="confirm-btn"
              >
                {publishText}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PublishConfirmDialog;
